import { translate } from 'src/utils/i18n-translate'
import { registerLazyJexlExtension } from 'src/utils/lazy-jexl-extension'

/**
 * Use-case code attached to configuration: every lazy JEXL extension of the app is declared here
 * (and nowhere else). Only names, pending values and a dynamic import live in the main bundle;
 * the code behind them loads on the first call. See `docs/developer/config-extensions.md`.
 */

// JetConnect POC assignment (configs/jetconnect): ranked POC picker, assign / unassign, auto-assign.
registerLazyJexlExtension({
  id: 'jetconnect',
  functions: {
    // The OptionPicker envelope: disabled, and the assigned POC stays visible while loading.
    jcPocOptions: {
      pending: (row?: { AssignedPoc?: string }) => ({
        state: 'loading',
        options: [],
        message: row?.AssignedPoc || undefined
      }),
      failed: { state: 'error', options: [] }
    },
    // The picker is disabled while loading, so these are not reachable; the cell shows its own failure text.
    jcAssignPoc: { pending: { status: 'error' } },
    jcUnassignPoc: { pending: { status: 'error' } },
    jcAutoAssign: { pending: 'loading' },
    // Disabled toolbar button whose label says why.
    jcAutoAssignBlocked: { pending: true },
    jcAutoAssignLabel: {
      pending: () =>
        translate('jetconnect.autoAssign.buttonBlocked', {
          reason: translate('jetconnect.autoAssign.dataLoading')
        })
    },
    jcPreviewPoc: { pending: undefined }
  },
  load: () => import('components/features/jetconnect/PocAssignment/extension')
})
